<app-modal-frame
  [headerText]="modalInput.header"
  [hasHeaderCloseButton]="false"
  (emitExit)="onClose(buttonClick.ACCEPT)"
>
  <ion-grid class="warning-modal-container" [ngClass]="modalInput.extraClass">
    <ion-row>
      <ion-col class="body">
        {{ modalInput.body }}
      </ion-col>
    </ion-row>
    @if (modalInput.extraText) {
      <ion-row>
        <ion-col class="body extra-text-container">
          <ion-icon class="image" [src]="IMAGES.YIELD" [alt]="'yield'" />
          {{ modalInput.extraText }}
        </ion-col>
      </ion-row>
    }
    <ion-row>
      <ion-col
        class="buttons"
        [ngClass]="{ 'ion-justify-content-end': !hasRejectButton }"
      >
        @if (hasRejectButton) {
          <ion-button
            expand="block"
            fill="outline"
            class="reject-button"
            (click)="onClose(buttonClick.REJECT)"
          >
            {{ rejectText }}
          </ion-button>
        }
        <ion-button
          expand="block"
          fill="solid"
          class="confirm-button"
          (click)="onClose(buttonClick.ACCEPT)"
        >
          {{ confirmText }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</app-modal-frame>
